import {FIELD_TYPE} from "types/enums";
const {INPUT} = FIELD_TYPE;
const css = {xs: 24, sm: 24, md: 24, lg: 12, xl: 12};
const fields = [
  {
    key: "name",
    name: "name",
    label: "Tên",
    type: INPUT,
    css: css,
    rules: [{required: true, message: "Chưa nhập tên"}],
  },

  {key: "moTa", name: "moTa", label: "Mô tả", type: INPUT, css: css},
];
export {fields};
